// Options passed to FB.login for WhatsApp Embedded Signup. The result
// (authResponse.code) arrives directly in the login callback — no redirects.
export const FB_LOGIN_CONFIG = (existingNumber = false) => ({
  config_id: "1623056195954481",
  response_type: "code",
  override_default_response_type: true,
  extras: existingNumber
    ? { setup: {}, featureType: "whatsapp_business_app_onboarding", sessionInfoVersion: "3" }
    : { setup: {}, sessionInfoVersion: "3" },
});

// Callback results Meta sends back to `/agent-whatsapp?wa=<value>` after the
// WhatsApp Embedded Signup popup finishes.
export const WA_CALLBACK_MESSAGES = {
  connected: { type: "success", text: "WhatsApp connected!" },
  failed: { type: "error", text: "Connection failed. Please try again." },
  cancelled: { type: "error", text: "Setup was cancelled." },
  duplicate: {
    type: "error",
    text: "This number is already used by another account.",
  },
  nowaba: { type: "error", text: "No WhatsApp Business Account found." },
  nophone: { type: "error", text: "No phone number found." },
};

// Conversation numbers arrive from the API without a country prefix (92300...)
export const formatWhatsappPhone = (phoneNumber) => {
  if (!phoneNumber) return "";
  return `+${String(phoneNumber).replace(/[^\d]/g, "")}`;
};

export const formatWhatsappDate = (value, withTime = false) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";

  return date.toLocaleString(undefined, {
    day: "2-digit",
    month: "short",
    year: "numeric",
    ...(withTime ? { hour: "2-digit", minute: "2-digit" } : {}),
  });
};
